module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/187-vanuatu-efdc38fef2c7a6d7a7d1e27f3eb0b9b7.svg";